import { Helmet } from 'react-helmet';
import seoMetaData from '../../../Include/Seo/seoMetaData';
import Navbar from '../../../Include/Navbar/Navbar';
import Footer from '../../../Include/Footer/Footer';
import Breadcrumb from '../MobileApp/Breadcum';
import breadcrumbData from '../Data/breadcrumbData';
import whyusData from '../Data/whyusData';
import aboutData from '../Data/aboutData';
import contactData from '../Data/contactData';
import faqData from '../Data/faqData';
import '../../../../assets/css/services.css'; // Importing the CSS file for this component
import About from '../MobileApp/About';
import Whyus from '../MobileApp/Whyus';
import Contact from '../MobileApp/Contact';
import Faq from '../MobileApp/Faq';
import Contactus from '../../Home/Contact';

export default function Index() {
  const { title, description } = seoMetaData.micro;
  return (
    <>
     <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href="https://www.cloudkode.com/services/microservices-development" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": [{
                "@type": "Question",
                "name": "What are microservices?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Microservices are a software architecture style that structures an application as a collection of loosely coupled services."
                }
              },{
                "@type": "Question",
                "name": "How do microservices improve scalability?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Microservices allow individual components to be scaled independently, improving resource utilization and performance."
                }
              },{
                "@type": "Question",
                "name": "Can you help with migrating to a microservices architecture?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, we provide consulting and development services to help businesses transition to a microservices architecture."
                }
              },{
                "@type": "Question",
                "name": "What technologies do you use for microservices development?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "We use a variety of technologies including Docker, Kubernetes, and various programming languages based on project requirements."
                }
              }]
            }
          `}
        </script>
      </Helmet>
   <Navbar />
   <Breadcrumb data={breadcrumbData.micro} /> 
   <About data={aboutData.micro} />
   <Whyus data={whyusData.micro}/>
   <Contact data={contactData.micro}/>
   <Faq data={faqData.micro}/>
   <Contactus/>
   <Footer/>
   </>
  )
}
